// Utility to generate a new configId and store it in localStorage
import { v4 as uuidv4 } from 'uuid';

export function createNewConfigId() {
  const newId = uuidv4();
  localStorage.setItem('currentConfigId', newId);
  return newId;
}
